@if (showPagination()) {
<section>
  <ul id="pagination-wrapper-container">
    <!-- Previous -->
    <li class="pagination-item" [class.disabled]="onFirstPage() || !hasPages()">
      <a class="pagination-link" (click)="clickPageNo(getPagePrevious())">
        <mat-icon class="material-icons-sharp">keyboard_arrow_left</mat-icon>
      </a>
    </li>
    <!-- Page Index -->
    @for (page of getPageIndicies(); track page; let i = $index) {
    <li class="pagination-item" [ngClass]="{ active: onPageIndex(i), disabled: showDots(i) }">
      @if (showDots(i)) {
      <a class="pagination-link">...</a>
      } @if (!hidePageIndex(i)) {
      <a class="pagination-link" (click)="clickPageNo(i + 1)">{{ i + 1 }}</a>
      }
    </li>
    }
    <!-- Next -->
    <li class="pagination-item" [class.disabled]="onLastPage() || !hasPages()">
      <a class="pagination-link" (click)="clickPageNo(getPageNext())">
        <mat-icon class="material-icons-sharp">keyboard_arrow_right</mat-icon>
      </a>
    </li>
  </ul>
</section>
}
